import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AuthContainer from "../../containers/Auth";
import AuthInputText from "../../components/AuthInput";
import { useNavigate } from "react-router-dom";
import { TokenContext } from "../../service/context/tokencontent";
import CustomModal from "../../components/Modal";
import { AUTH_URL } from "../../common/common";
import { validationSchema } from "../../service/validation/verifiedOwerKYC";
import { ApiService } from "../../service/api.service";
import { check } from "../../common/svg";
import SecureImage from "../../components/BucketImage/Image";

const VerifiedKYC = () => {
  const apiService = new ApiService();
  const { setToken } = useContext(TokenContext)!;
  const [isModalOpen, setModalOpen] = useState(false);
  const businessType = localStorage.getItem("businessType");
  let parsedBusinessType = businessType ? JSON.parse(businessType) : null;
  let entityId = localStorage.getItem("entity_id");
  const navigate = useNavigate();
  let licence = localStorage.getItem("licence-moto") || ""
  let vehicle = localStorage.getItem("vehicle-moto") || ""

  // Form setup using React Hook Form with validation
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    defaultValues: {
      vehicle_number: vehicle,
      licence_number: licence,
      address: "",
      licence_name: "",
      vehicle_details: "",
    },
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  // Watch for form field values
  const vehicleNumber = watch("vehicle_number", "");
  const licenceNumber = watch("licence_number", "");
  const licenceName = watch("licence_name", "");
  const address = watch("address", "");
  const vehicleDetails = watch("vehicle_details", "");

  // Open and close modal
  const openModal = () => setModalOpen(true);

  const closeModal = () => {
    // navigate("/businesstype");
    setModalOpen(false);
  };

  // Handle form submission
  const onSubmit = async (data: any) => {
    try {
      let newData = {
        type: "Vehicle",
        businessIds: parsedBusinessType,
        entityId: entityId,
        vehicleInfo: JSON.stringify(data.vehicle_details),
        licenseAddress: JSON.stringify(data.address),
        licenseName: data.licence_name,
        licenseNumber: data.licence_number,
        vehicleNumber: data.vehicle_number,
      };
      const response: any = await apiService.postApi(
        `${AUTH_URL}/business/store-route`,
        newData
      );
      if (response.status === "200") {
        const tokenValue = response.body.authToken; // Simulated token
        // localStorage.setItem("user_data_motsop", JSON.stringify(response.body.data));
        localStorage.setItem("motosop", tokenValue); // Save token to localStorage
        localStorage.removeItem("licence-moto")
        localStorage.removeItem("vehicle-moto")
        setToken(tokenValue); // Update the context
        navigate("/dashboard");
      }
    } catch (error: any) {
      console.error("Verification Error:", error);
      alert(
        error.message ||
        "Failed to verify Licence or Vehicle Number. Please try again."
      );
    }
  };

  return (
    <AuthContainer>
      <div className="flex w-full rounded-[21.25px] min-h-[90vh] bg-white font-poppins">
        {/* <div className="bg-[#D9D9D9] rounded-[21.25px] w-full"></div> */}
        <div className="w-full h-full">
          <div className="md:mx-[8rem] my-[2rem] m-6">
            {/* Logo */}
            <div className="h-[100px] w-[239px] bg-[#D9D9D9] flex items-center justify-center">
              logo
            </div>
            <br />
            <p className="font-[700] text-[20px] font-poppins tracking-[1%]">
              Welcome aboard 👋
            </p>
            <p className="font-[400] font-poppins text-[14px] tracking-[1%] text-[#313957]">
              Owner Come Driver KYC
            </p>
            <br />
            {/* Form */}
            <form onSubmit={handleSubmit(onSubmit)}>
              <AuthInputText
                label="Vehicle Number"
                value={vehicleNumber}
                errors={errors}
                placeholder="Enter Vehicle Number"
                autoComplete="one-time-code"
                name="vehicle_number"
                type="text"
                verified={true}
                register={register}
              />
              <AuthInputText
                label="Vehicle Details"
                value={vehicleDetails}
                errors={errors}
                placeholder="Enter Vehicle Details"
                autoComplete="one-time-code"
                name="vehicle_details"
                type="text"
                register={register}
              />
              <AuthInputText
                label="Licence Number"
                value={licenceNumber}
                verified={true}
                errors={errors}
                placeholder="Enter Licence Number"
                autoComplete="one-time-code"
                name="licence_number"
                type="text"
                register={register}
              />
              <AuthInputText
                label="Licence Name"
                value={licenceName}
                errors={errors}
                placeholder="Enter Licence Name"
                autoComplete="one-time-code"
                name="licence_name"
                type="text"
                register={register}
              />
              <AuthInputText
                label="Address"
                value={address}
                errors={errors}
                placeholder="Enter Address"
                autoComplete="one-time-code"
                name="address"
                type="text"
                register={register}
              />

              {/* Submit button */}
              <div className="flex items-center justify-center">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="mt-4 p-2 w-[245px] h-[40px] font-[400] text-[16px] leading-[22.96px] tracking-[1%] bg-[#444FBD] rounded-[20px] text-white"
                >
                  {isSubmitting ? "Continuing..." : "Continue"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Success Modal */}
      <CustomModal
        isOpen={isModalOpen}
        content={
          <div className="flex flex-col items-center">
            <SecureImage

              fileKey={check}
              alt="check"
              className="mb-2"
            />
            <p className="text-[18px] font-[600] text-[#4B4B4B]">
              OTP Verified Successfully
            </p>
            <p className="text-[16px] font-[600] text-[#4B4B4B]">
              Your Account Created Successfully
            </p>
            <br />
            <button
              onClick={closeModal}
              className="bg-[#444FBD] rounded-[5px] h-[37px] w-[99px] text-white"
            >
              OK
            </button>
          </div>
        }
        onClose={closeModal}
      />
    </AuthContainer>
  );
};

export default VerifiedKYC;
